import {TextInputProps} from "@vebox/etui-core";
import {INPUT_BORDER_BOX} from "../../../components/common/etui_components_styles";

export const INPUT_BORDER_BOX_WITH_MARGIN: TextInputProps['styles'] = {
    ...INPUT_BORDER_BOX,
    input: {
        ...INPUT_BORDER_BOX.input,
        color: "white",
        bg: "#303030"
    }
};
